// Keep in sync with //depot/devmainoverride/tenantolk/outlook/core/staging/translator/IEmailTranslationMetrics.h
export enum EmailTranslationMetricsMessageBucket {
    Default = -2,
    ErrorOrUnexpectedValue = -1,
    ZeroToFiveThousand = 5,
    FiveToTenThousand = 10,
    TenToOneHundredThousand = 100,
    OneHundredToTwoHundredThousand = 200,
    // This range is open in case we need to add more buckets.
    MaxValue = Number.MAX_VALUE,
}
